<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-button type="primary" icon="plus" @click="addTemplate" style="width: 100%" size="mini">添加分类</el-button>
      </el-col>
      <el-col :md="8" :lg="4">
          <el-select size="small" v-model="params.type" clearable placeholder="分类类型" @change="typesearch">
              <el-option v-for="item in type" :key="item.value" :label="item.name" size="mini" :value="item.value"> </el-option>
          </el-select>
      </el-col>
      <el-col :span="5">
        <el-input placeholder="分类名称" v-model="params.cate_name" style="width: 100%" size="mini"><el-button slot="append" icon="el-icon-search" @click="searchData"></el-button></el-input>
      </el-col>
    </el-row>
   <el-table :data="catesList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="cate_id" label="ID" width="100"></el-table-column>
      <el-table-column prop="sort" label="排序" width="100">
        <template slot-scope="scope">
          <input style="width:50px" placeholder="0" v-model="scope.row.sort"  @change="saveSort(scope.$index, scope.row)"/>
        </template>
      </el-table-column>
      <el-table-column prop="cate_name" label="分类名称" width="250">
        <template slot-scope="scope">
        <el-tag>{{scope.row.cate_name}}</el-tag>
      </template>
      </el-table-column>
      <el-table-column prop="front_show" align="center" label="前台是否显示" width="120" >
          <template slot-scope="scope">
              <el-switch v-model="scope.row.front_show"  active-value="1" inactive-value="0" active-color="#13ce66"  inactive-color="#ff4949" @change="switchAuth(scope.$index, scope.row)"></el-switch>
          </template>
      </el-table-column>
      <el-table-column prop="description" label="分类描述" width="180"></el-table-column>
      <el-table-column prop="type" label="分类类型" width="90">
          <template slot-scope="scope">
              <el-tag size="mini" effect="plain" type="success" v-if="scope.row.type=='1'">普通视频</el-tag>
              <el-tag size="mini" effect="plain" v-else>短视频</el-tag>
          </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div class="operating-icons">
            <i class="iconfont icon-edit1" @click="editAction(scope.$index, scope.row)"></i>
            <i class="mark iconfont icon-trash-alt1" @click="deleteAction(scope.$index, scope.row)"></i>
          </div>
        </template>
      </el-table-column>

    </el-table>
    <div v-if="total_count > params.page_size" class="content-center content-top-padded">
     <el-pagination
     layout="prev, pager, next"
     @current-change="handleCurrentChange"
     :current-page.sync="params.page"
     :total="total_count" :page-size="params.page_size">
     </el-pagination>
   </div>
   <el-dialog title="添加、编辑分类" width="40%" :visible.sync="memberTagDialog" :before-close="handleCancelLabelsDialog">
     <template>
       <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">
         <el-form-item class="content-left" label="分类名称" prop="cate_name" :rules="[{ required: true, message: '请输入分类名称', trigger: 'blur' }]">
           <el-input placeholder="请输入标签名称" v-model="form.cate_name"></el-input>
         </el-form-item>
         <el-form-item class="content-left" label="分类说明">
           <el-input type="textarea" :rows="3" placeholder="请输入分类说明" v-model="form.description"></el-input>
         </el-form-item>
         <el-form-item class="content-left" label="前台显示">
           <el-radio-group v-model="form.front_show" size="small">
             <el-radio label="1" border>显示</el-radio>
             <el-radio label="0" border>不显示</el-radio>
           </el-radio-group>
         </el-form-item>
         <el-form-item class="content-left" label="分类类型">
           <el-radio-group v-model="form.type" size="small">
             <el-radio label="1" border>普通视频</el-radio>
             <el-radio label="2" border>短视频</el-radio>
           </el-radio-group>
         </el-form-item>  
         <el-form-item class="content-center">
           <el-button type="primary" @click="saveCateData">确定保存</el-button>
         </el-form-item>
       </el-form>
     </template>
   </el-dialog>
  </div>
</template><script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import { saveCate, getCateList, updateCate, deleteCate} from '@/api/live'
  export default {
    data () {
      return {
        isEdit: false,
        catesList: [],
        loading: false,
        type:[
              { name: '普通视频', value: 1 },
              { name: '短视频', value: 2 },
          ],
        total_count: 0,
        params: {
          page: 1,
          pageSize: 20,
          cate_name: '',
          sort: '',
        },
        form: {
          cate_id: '',
          cate_name: '',
          description: '',
          front_show: '0',
          type:'1',
        },
        memberTagDialog: false
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getDataList()
      },
      addTemplate () { // 添加商品
        this.memberTagDialog = true
        this.form = {cate_id: '',description: ''}
      },
      editAction (index, row) { // 编辑商品弹框
        this.form = row
        this.memberTagDialog = true
      },
      preview (index, row) { // 预览弹框
        this.dialogVisible = true
        this.dataInfo = row
      },
      searchData () {
        this.params.page = 1
        this.getDataList()
      },
      getDataList () {

        this.loading = true
        getCateList(this.params).then(response => {
          
          this.catesList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },
      typesearch (){
          this.params.page = 1
          getCateList({page:1,pageSize:-1,type:this.params.type}).then(res=>{
              if(res.data){
                  this.category = res.data.data.list
              }
          })
          this.getDataList()
      },
      deleteAction (index, row) {
        
        this.$confirm('此操作将删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deleteCate(row.cate_id).then(response => {
            
            this.catesList.splice(index, 1)
            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 5 * 1000
            })
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '删除失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      getTaskTime (strDate) {
          let date = new Date(strDate)
          let y = date.getFullYear()
          let m = date.getMonth() + 1
          m = m < 10 ? ('0' + m) : m
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          let str = y+"-"+m+"-"+d
          return str
      },
      switchAuth(index, row) {
          let params = {
              'cate_name': row.cate_name ,
              'front_show': row.front_show ,
          }
          updateCate(row.cate_id,params).then(res => {
              if (res.data.data) {
                  this.$message({
                      message: '操作成功',
                      type: 'success',
                      duration: 2 * 1000
                  })
                  this.getDataList()
              }
          })
      },
      saveSort(index, row) {
          let params = {
              'cate_name': row.cate_name ,
              'sort': row.sort ,
          }
          updateCate(row.cate_id,params).then(res => {
              if (res.data.data) {
                  this.$message({
                      message: '操作成功',
                      type: 'success',
                      duration: 2 * 1000
                  })
                  this.getDataList()
              }
          })
      },
      getTimeStr (date) {
        return this.getTaskTime(new Date(parseInt(date) * 1000))
      },
      handleCancelLabelsDialog () {
        this.memberTagDialog = false
      },
      saveCateData () {
        this.memberTagDialog = false
        if (this.form.cate_id) {
          updateCate(this.form.cate_id, this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })
        } else {
          saveCate(this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })
        }
      }
    },
    mounted () {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// category.vue?514cf48d